import { Empty } from "antd";

export default function EmptyComponent({
  title = "No data available",
  color,
}: {
  title?: string;
  color?: string;
}) {
  return (
    <div className="mt-40 mb-40">
      <Empty
        description={<span style={{ color }}>{title}</span>}
        image={"/assets/images/food-plate.svg"}
      />
    </div>
  );
}
